import { useEffect, useState } from 'react';

// default throw radius (m) per sprinkler catalog item
export const SPRAY_DEF = { g03: 8, g27: 4, g28: 12, g29: 6, g30: 2 };
export const isSprinkler = (f) => f && SPRAY_DEF[f.catId] != null;
export const sprayR = (f) => { const v = parseFloat(String(f.throw ?? '').replace(',', '.')); return v > 0 ? v : SPRAY_DEF[f.catId]; };
export const sprayArc = (f) => +f.arc || 360;

const KEY = 'giss_spray';
export const sprayOn = () => localStorage.getItem(KEY) !== '0';
export const setSprayOn = (v) => { localStorage.setItem(KEY, v ? '1' : '0'); window.dispatchEvent(new Event('giss-spray')); };
export function useSprayOn() {
  const [on, setOn] = useState(sprayOn);
  useEffect(() => { const h = () => setOn(sprayOn()); window.addEventListener('giss-spray', h); return () => window.removeEventListener('giss-spray', h); }, []);
  return on;
}

// polygon of a circle sector: dir = centre bearing (deg, 0 = north), arc = opening angle
export function sprayShape(f) {
  const r = sprayR(f), arc = sprayArc(f), dir = +f.dir || 0;
  const mLat = 111320, mLon = 111320 * Math.cos((f.lat * Math.PI) / 180);
  const n = Math.max(12, Math.round(arc / 6)), a0 = dir - arc / 2;
  const pts = Array.from({ length: n + 1 }, (_, i) => {
    const a = ((a0 + (arc * i) / n) * Math.PI) / 180;
    return [f.lat + (r * Math.cos(a)) / mLat, f.lon + (r * Math.sin(a)) / mLon];
  });
  return arc >= 360 ? pts.slice(0, -1) : [[f.lat, f.lon], ...pts];
}
